<template>
  <v-app>
    <the-header></the-header>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer class="flex-grow-0 justify-center py-2" color="transparent">
      <nav aria-label="서비스 안내" class="d-flex flex-wrap justify-center ga-4 text-caption">
        <a href="https://swiun.kr/" target="_blank" rel="noopener noreferrer" aria-label="쉬운 홈 (새 탭)" class="text-grey-darken-1 py-1">쉬운 홈</a>
        <a href="https://swiun.kr/privacy" target="_blank" rel="noopener noreferrer" aria-label="개인정보처리방침 (새 탭)" class="text-grey-darken-1 font-weight-medium py-1">개인정보처리방침</a>
        <a href="mailto:contact@swiun.kr" class="text-grey-darken-1 py-1">문의</a>
      </nav>
    </v-footer>
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  /* margin-top: 10px; */
}

.v-btn:active {
  transform: scale(0.95);
  transition: transform 0.1s ease-in-out;
}
</style>
